import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { useTranslation } from "gatsby-plugin-react-i18next"
import vakif1 from "../../assets/img/vakif1.png"
import vakif2 from "../../assets/img/vakif2.png"
import vakif3 from "../../assets/img/vakif3.png"
import vakif5 from "../../assets/img/vakif-5.png"
import vakif4 from "../../assets/img/vakif-yeni-1.png"

export default function VakifKatilimProjesi() {
  const { t } = useTranslation()
  return (
    <Layout>
      <SEO title="Vakıf Katılım Projesi" />
      <div className="projeler-container page">
        <div className="ic-proje">
          <img src={vakif3} alt="" className="proje-icGorsel" />
          <div className="proje-kunye">
            <span>{t("project-brand")}</span>: {t("vakif-katilim")}
            <br />
            <span>{t("project-sector")}</span>: {t("finans")}
            <br />
            <span>{t("project-subject")}</span>: {t("logonun-yorumu")}
            <br />
            <span>{t("project-artwork")}</span>: {t("vakif-duasi")}
          </div>
          <img src={vakif4} alt="" className="proje-icGorsel" />
        </div>
        <div className="seperator"></div>
        <div className="ic-proje">
          <img src={vakif1} alt="" className="proje-icGorsel" />
          <div className="proje-kunye">
            <span>{t("project-brand")}</span>: {t("vakif-katilim")}
            <br />
            <span>{t("project-sector")}</span>: {t("finans")}
            <br />
            <span>{t("project-subject")}</span>: {t("vip-takvim")} - 2017
            <br />
            <span>{t("project-artwork")}</span>: {t("modern-13")}
          </div>
          <img src={vakif2} alt="" className="proje-icGorsel" />
        </div>
        <div className="seperator"></div>
        <div className="ic-proje">
          <img src={vakif3} alt="" className="proje-icGorsel" />
          <div className="proje-kunye">
            <span>{t("project-brand")}</span>: {t("vakif-katilim")}
            <br />
            <span>{t("project-sector")}</span>: {t("finans")}
            <br />
            <span>{t("project-subject")}</span>: {t("vakif-sube")}
            <br />
            <span>{t("project-artwork")}</span>: {t("vakif-duasi")}
          </div>
          <img src={vakif5} alt="" className="proje-icGorsel" />
        </div>
      </div>
    </Layout>
  )
}
